import React, { useContext, useState, useEffect } from "react";
import logomuseu from "../../assets/logomuseu.png";
import userPhoto from "../../assets/user.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt, faUser, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { useNavigate, Link } from "react-router-dom";
import { AuthContext } from "../../contexts/AuthContext";
import useFetch from "../../hooks/useFetch";

export default function AdminNavbar() {
    const { user, signout } = useContext(AuthContext);
    const navigate = useNavigate();
    const { get } = useFetch();

    const [usuario, setUsuario] = useState({ id_usuario: "", nome_usuario: "", base64: "" });

    useEffect(() => {
        if (user?.id_usuario) {
            buscarUsuario(user.id_usuario);
        }
    }, [user?.id_usuario]);

    async function buscarUsuario(id) {
        try {
            let response = await get("/usuario/" + id);
            if (response.status === 200 && response.result.data) {
                setUsuario(response.result.data);
            }
        } catch (error) {
            console.error("Erro no buscarUsuario():", error);
        }
    }

    const handleLogout = async () => {
        await signout();
        navigate('/');
    }

    return (
        <nav className="admin-navbar">
            <div className="container-fluid d-flex align-items-center justify-content-between px-4">
                
                {/* Lado Esquerdo: Logo (Link para Dashboard) */}
                <Link to="/admin" className="navbar-logo-link">
                    <img src={logomuseu} alt="Logo Museu" className="nav-logo-img" />
                    <span className="ms-2 d-none d-sm-inline navbar-brand-text">Painel Administrativo</span>
                </Link>

                {/* Lado Direito: Perfil do Usuário */}
                <div className="dropdown">
                    <button className="user-profile-toggle" type="button" id="userMenu" data-bs-toggle="dropdown" aria-expanded="false">
                        <div className="user-info d-none d-md-block text-end me-2">
                            <span className="user-name">{usuario.nome_usuario || "Administrador"}</span>
                            <span className="user-role">FMRP-USP</span>
                        </div>
                        <div className="avatar-wrapper">
                            {usuario.base64 ? (
                                <img src={`data:image/jpeg;base64,${usuario.base64}`} alt="User" />
                            ) : (
                                <img src={userPhoto} alt="User Default" />
                            )}
                        </div>
                        <FontAwesomeIcon icon={faChevronDown} className="ms-2 chevron-icon" />
                    </button>

                    <ul className="dropdown-menu dropdown-menu-end modern-dropdown" aria-labelledby="userMenu">
                        <li className="dropdown-header">Minha Conta</li>
                        <li>
                            <button className="dropdown-item" onClick={() => navigate("/admin/usuarios/" + usuario.id_usuario, { state: { acao: "EdicaoPropria" } })}>
                                <FontAwesomeIcon icon={faUser} className="me-2 text-teal" /> Perfil
                            </button>
                        </li>
                        <li><hr className="dropdown-divider" /></li>
                        <li>
                            <button className="dropdown-item text-danger" onClick={handleLogout}>
                                <FontAwesomeIcon icon={faSignOutAlt} className="me-2" /> Sair
                            </button>
                        </li>
                    </ul>
                </div>

            </div>
        </nav>
    );
};